import { registerWidget } from "../widget";
import makeWidgetFor from "../../viewModels/makeWidgetFor";
import OutagesWidgetViewModel from "../../viewModels/outages/outagesWidgetViewModel";
import LazyInitializationService from "../../services/initialization/lazyInitializationService";

const OutagesWidgetIdentifier = "edaz-outages";

registerWidget({
  component: makeWidgetFor(OutagesWidgetIdentifier, [OutagesWidgetViewModel], LazyInitializationService),
  configuration: {
    tagname: OutagesWidgetIdentifier,
  },
});
